module.exports = __webpack_public_path__ + "static/media/Community4.78677fce.png";